import React from "react";

export const isFieldDisabled = (fieldEditable: any) => {
  const userRole = localStorage.getItem("user_role");
  return !fieldEditable && userRole !== "admin";
};
